import { render } from "./Mailings.vue?vue&type=template&id=42b821a6&ts=true"
import script from "./Mailings.vue?vue&type=script&lang=ts"
export * from "./Mailings.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/clickfun/frontend/clickfun_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__